import React, { useState, useEffect } from "react";



import { collection, query, where, addDoc, getDocs, updateDoc, doc } from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2";
import { useNavigate, Link, useParams } from 'react-router-dom';

const CourseTimestampUpdate = () => {
    const [loading, setLoading] = useState(false);
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState("");
    const [day, setDay] = useState("");
    const [timestamps, setTimestamps] = useState([{ time: "", title: "" }]);

    const navigate = useNavigate();
    const [email, setEmail] = useState("");

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        setEmail(storedUsername)

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }

    }, []);

    // ✅ Fetch course names from "nv_courses" and populate dropdown
    useEffect(() => {
        const fetchCourses = async () => {
            const courseQuery = query(collection(db, "nv_courses"));
            const querySnapshot = await getDocs(courseQuery);
            const courseList = querySnapshot.docs.map(doc => doc.data().course_name);
            setCourses(courseList);
        };
        fetchCourses();
    }, []);

    // ✅ Handle adding new timestamp fields dynamically
    const addTimestampField = () => {
        setTimestamps([...timestamps, { time: "", title: "" }]);
    };

    // ✅ Handle updating timestamp field values
    const updateTimestampField = (index, key, value) => {
        const updatedTimestamps = [...timestamps];
        updatedTimestamps[index][key] = value;
        setTimestamps(updatedTimestamps);
    };

    // ✅ Handle Firestore update
    // const updateLessonTimes = async () => {
    //     if (!selectedCourse || !day) {
    //         Swal.fire("Error", "Please fill all fields!", "error");
    //         return;
    //     }

    //     setLoading(true);
    //     try {
    //         const q = query(
    //             collection(db, "nv_enrolled_courses"),
    //             where("course_name", "==", selectedCourse)
    //         );

    //         const querySnapshot = await getDocs(q);
    //         if (querySnapshot.empty) {
    //             Swal.fire("Error", "No matching enrolled users found!", "error");
    //             setLoading(false);
    //             return;
    //         }

    //         let updatedCount = 0;
    //         for (const courseDoc of querySnapshot.docs) {
    //             const courseRef = doc(db, "nv_enrolled_courses", courseDoc.id);
    //             const courseData = courseDoc.data();

    //             // ✅ Update the specific lesson based on 'day'
    //             const updatedLessons = courseData.lessons.map((lesson, index) =>
    //                 index === parseInt(day) - 1
    //                     ? { ...lesson, timestamp: timestamps }
    //                     : lesson
    //             );

    //             await updateDoc(courseRef, { lessons: updatedLessons });
    //             updatedCount++;
    //         }

    //         setLoading(false);
    //         const logEntry = {
    //             created_date: new Date(), // Current timestamp
    //             email: email || "unknown", // Fallback if email is missing
    //             page: "CourseTimestampUpdate",
    //             action: `Course name : ${selectedCourse}, Updated timestamp : ${timestamps}`,
    //         };

    //         await addDoc(collection(db, "nv_backend_logs"), logEntry);
    //         console.log("Log entry added:", logEntry);
    //         Swal.fire("Success", `Updated lesson for ${updatedCount} users!`, "success");
    //     } catch (error) {
    //         console.error("Error updating lesson:", error);
    //         setLoading(false);
    //         Swal.fire("Error", "Failed to update lesson!", "error");
    //     }
    // };

    const updateLessonTimes = async () => {
        if (!selectedCourse || !day) {
            Swal.fire("Error", "Please fill all fields!", "error");
            return;
        }

        setLoading(true);
        try {
            // 1. Update enrolled courses (user-specific)
            const q = query(
                collection(db, "nv_enrolled_courses"),
                where("course_name", "==", selectedCourse)
            );

            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) {
                Swal.fire("Error", "No matching enrolled users found!", "error");
                setLoading(false);
                return;
            }

            let updatedCount = 0;
            for (const courseDoc of querySnapshot.docs) {
                const courseRef = doc(db, "nv_enrolled_courses", courseDoc.id);
                const courseData = courseDoc.data();

                const updatedLessons = courseData.lessons.map((lesson, index) =>
                    index === parseInt(day) - 1
                        ? { ...lesson, timestamp: timestamps }
                        : lesson
                );

                await updateDoc(courseRef, { lessons: updatedLessons });
                updatedCount++;
            }

            // 2. ✅ Now update the main course in nv_courses
            const courseQuery = query(
                collection(db, "nv_courses"),
                where("course_name", "==", selectedCourse)
            );

            const courseSnap = await getDocs(courseQuery);
            if (!courseSnap.empty) {
                const courseDoc = courseSnap.docs[0];
                const courseRef = doc(db, "nv_courses", courseDoc.id);
                const courseData = courseDoc.data();

                const updatedCourseLessons = courseData.lessons.map((lesson, index) =>
                    index === parseInt(day) - 1
                        ? { ...lesson, timestamp: timestamps }
                        : lesson
                );

                await updateDoc(courseRef, { lessons: updatedCourseLessons });
            }

            setLoading(false);
            const logEntry = {
                created_date: new Date(),
                email: email || "unknown",
                page: "CourseTimestampUpdate",
                action: `Course name: ${selectedCourse}, Updated timestamp: ${timestamps}`,
            };

            await addDoc(collection(db, "nv_backend_logs"), logEntry);
            console.log("Log entry added:", logEntry);
            Swal.fire("Success", `Updated lesson for ${updatedCount} users and course!`, "success");
        } catch (error) {
            console.error("Error updating lesson:", error);
            setLoading(false);
            Swal.fire("Error", "Failed to update lesson!", "error");
        }
    };



    const updateCourse002Timestamps = async () => {
        // const newTimestamps = [
        //     [
        //         { time: "00:00", title: "Introduction" },
        //         { time: "00:09", title: "Foundation of Pattern" },
        //         { time: "27:52", title: "Fabric Knowledge" },
        //         { time: "34:32", title: "Knowledge Of Measurement" },
        //         { time: "49:32", title: "Q & A session" }
        //     ],
        //     [
        //         { time: "00:00", title: "Introduction" },
        //         { time: "05:40", title: "Basics of Pattern" },
        //         { time: "01:14:29", title: "Pattern Drawing" },
        //         { time: "01:36:20", title: "Q & A session" }
        //     ],
        //     [
        //         { time: "00:00", title: "Introduction" },
        //         { time: "01:15", title: "Manipulation of Pattern" },
        //         { time: "03:42", title: "Pattern of Flared Trouser" },
        //         { time: "19:10", title: "Pattern of Pajama" },
        //         { time: "27:35", title: "Pattern of Shorts" },
        //         { time: "31:42", title: "Pattern of Pant and Palazzo " },
        //         { time: "36:38", title: "Kalidar Palazzo " },
        //         { time: "01:16:20", title: "Pattern of Pocket & Fly Zipper" },
        //         { time: "01:35:27", title: "Pattern Trace on Fabric" },
        //         { time: "01:44:53", title: "Q & A session" }
        //     ],
        //     [
        //         { time: "00:00", title: "Introduction" },
        //         { time: "03:15", title: "Dart stitching" },
        //         { time: "27:17", title: "Attaching zipper fly" },
        //         { time: "39:55", title: "Attaching pockets" },
        //         { time: "49:31", title: "Stitching pant sides" },
        //         { time: "01:15:08", title: "Attaching Belt" },
        //         { time: "01:25:40", title: "Q & A session" }
        //     ],
        //     [
        //         { time: "00:00", title: "Introduction" },
        //         { time: "23:20", title: "Attaching Pockets" },
        //         { time: "28:24", title: "Attaching Belts" },
        //         { time: "37:40", title: "Attaching Zipper" },
        //         { time: "48:26", title: "Attaching Elastic" },
        //         { time: "01:29:02", title: "Q & A Session" }
        //     ]
        // ];
        const newTimestamps = [
            [
                { "time": "00:00", "title": "Introduction" },
                { "time": "00:09", "title": "Foundation of Pattern" },
                { "time": "27:52", "title": "Fabric Knowledge" },
                { "time": "34:32", "title": "Knowledge Of Measurement" },
                { "time": "49:32", "title": "Q & A session" }
            ],
            [
                { "time": "00:00", "title": "Introduction" },
                { "time": "05:40", "title": "Basics of Pattern" },
                { "time": "01:14:29", "title": "Pattern Drawing" },
                { "time": "01:36:20", "title": "Q & A session" }
            ],
            [
                { "time": "00:00", "title": "Introduction" },
                { "time": "01:15", "title": "Manipulation of Pattern" },
                { "time": "03:42", "title": "Pattern of Flared Trouser" },
                { "time": "19:10", "title": "Pattern of Pajama" },
                { "time": "27:35", "title": "Pattern of Shorts" },
                { "time": "31:42", "title": "Pattern of Pant and Palazzo " },
                { "time": "36:38", "title": "Kalidar Palazzo " },
                { "time": "01:16:20", "title": "Pattern of Pocket & Fly Zipper" },
                { "time": "01:35:27", "title": "Pattern Trace on Fabric" },
                { "time": "01:44:53", "title": "Q & A session" }
            ],
            [
                { "time": "00:00", "title": "Introduction" },
                { "time": "03:15", "title": "Dart stitching" },
                { "time": "27:17", "title": "Attaching zipper fly" },
                { "time": "39:55", "title": "Attaching pockets" },
                { "time": "49:31", "title": "Stitching pant sides" },
                { "time": "01:15:08", "title": "Attaching Belt" },
                { "time": "01:25:40", "title": "Q & A session" }
            ], [
                { "time": "00:00", "title": "Introduction" },
                { "time": "23:20", "title": "Attaching Pockets" },
                { "time": "28:24", "title": "Attaching Belts" },
                { "time": "37:40", "title": "Attaching Zipper" },
                { "time": "48:26", "title": "Attaching Elastic" },
                { "time": "01:29:02", "title": "Q & A Session" }
            ]
        ];

        try {
            const q = query(
                collection(db, "nv_enrolled_courses"),
                where("course_id", "==", "002")
            );

            const snapshot = await getDocs(q);
            if (snapshot.empty) {
                console.warn("No enrolled courses found with course_id '002'");
                return;
            }

            for (const docSnap of snapshot.docs) {
                const docRef = doc(db, "nv_enrolled_courses", docSnap.id);
                const docData = docSnap.data();

                if (!Array.isArray(docData.lessons)) continue;

                const updatedLessons = docData.lessons.map((lesson, index) => ({
                    ...lesson,
                    timestamp: newTimestamps[index] || []
                }));

                await updateDoc(docRef, {
                    lessons: updatedLessons
                });

                console.log(`✅ Updated ${docSnap.id}`);
            }

            console.log("🎉 All matching documents updated.");
        } catch (err) {
            console.error("❌ Error updating timestamps:", err);
        }
    };



    return (
        // <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-md">
        //     <h2 className="text-2xl font-semibold text-gray-700 mb-4">Update Course Timestamp</h2>
        //     <div className="space-x-4 mb-4" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        //         {/* Course Dropdown */}
        //         <div className="flex-1">
        //             <label className="block font-medium text-gray-600">Select Course:</label>
        //             <select
        //                 value={selectedCourse}
        //                 onChange={(e) => setSelectedCourse(e.target.value)}
        //                 className="w-full px-3 py-2 border rounded-md shadow-sm"
        //             >
        //                 <option value="">-- Select Course --</option>
        //                 {courses.map((course, index) => (
        //                     <option key={index} value={course}>
        //                         {course}
        //                     </option>
        //                 ))}
        //             </select>
        //         </div>



        //         {/* Day */}
        //         <div className="flex-1">
        //             <label className="block font-medium text-gray-600">Day:</label>
        //             <input
        //                 type="number"
        //                 value={day}
        //                 onChange={(e) => setDay(e.target.value)}
        //                 className="w-full px-3 py-2 border rounded-md shadow-sm"
        //                 placeholder="Enter Day eg. (1 2 3)"
        //             />
        //         </div>
        //     </div>


        //     {/* Dynamic Timestamp Fields */}
        //     <div className="mb-4">
        //         <label className="block font-medium text-gray-600 mb-2">Timestamps:</label>
        //         {timestamps.map((timestamp, index) => (
        //             <div key={index} className="flex space-x-2 mb-2">
        //                 <input
        //                     type="text"
        //                     placeholder="Time (e.g., 10:50)"
        //                     value={timestamp.time}
        //                     onChange={(e) => updateTimestampField(index, "time", e.target.value)}
        //                     className="flex-1 px-3 py-2 border rounded-md shadow-sm mr-2"
        //                 />
        //                 <input
        //                     type="text"
        //                     placeholder="Title (e.g., Introduction)"
        //                     value={timestamp.title}
        //                     onChange={(e) => updateTimestampField(index, "title", e.target.value)}
        //                     className="flex-1 px-3 py-2 border rounded-md shadow-sm"
        //                 />
        //             </div>
        //         ))}
        //         <button
        //             onClick={addTimestampField}
        //             className="mt-2 px-4 py-2 bg-gray-600 text-white rounded-md"
        //         >
        //             + Add Timestamp
        //         </button>
        //     </div>

        //     {/* Submit Button */}
        //     <button
        //         onClick={updateLessonTimes}
        //         className={`w-full py-2  btn btn-primary rounded-md text-white font-semibold transition ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}`}
        //         disabled={loading}
        //     >
        //         {loading ? "Updating..." : "Update TimeStamp"}
        //     </button>
        // </div>

        <>
            <>
                <div className="p-2 d-flex justify-content-between">
                    <Link to="/">
                        <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                    </Link>
                </div>

                <div className="p-3">
                    <h6 className="mb-2"> <h2>Update Course Timestamp</h2></h6>
                    <div className="card-header pb-0 px-3 d-flex justify-content-end">

                        <Link to="/course_video_update">
                            <button className="btn btn-success btn-sm mr-3" >
                                Course Video Update
                            </button>
                        </Link>
                        <Link to="/course_attendance_update">
                            <button className="btn btn-success btn-sm" >
                                Course Attendance Update
                            </button>
                        </Link>

                    </div>

                    <div className="table-responsive fix-width scroll-inner">
                        <div className="space-x-4 mb-4" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {/* Course Dropdown */}
                            <div className="flex-1">
                                <label className="block font-medium text-gray-600">Select Course:</label>
                                <select
                                    value={selectedCourse}
                                    onChange={(e) => setSelectedCourse(e.target.value)}
                                    className="w-full px-3 py-2 border rounded-md shadow-sm"
                                >
                                    <option value="">-- Select Course --</option>
                                    {courses.map((course, index) => (
                                        <option key={index} value={course}>
                                            {course}
                                        </option>
                                    ))}
                                </select>
                            </div>



                            {/* Day */}
                            <div className="flex-1">
                                <label className="block font-medium text-gray-600">Day:</label>
                                <input
                                    type="number"
                                    value={day}
                                    onChange={(e) => setDay(e.target.value)}
                                    className="w-full px-3 py-2 border rounded-md shadow-sm"
                                    placeholder="Enter Day eg. (1 2 3)"
                                />
                            </div>
                        </div>


                        {/* Dynamic Timestamp Fields */}
                        <div className="mb-4">
                            <label className="block font-medium text-gray-600 mb-2">Timestamps:</label>
                            {timestamps.map((timestamp, index) => (
                                <div key={index} className="flex space-x-2 mb-2">
                                    <input
                                        type="text"
                                        placeholder="Time (e.g., 10:50)"
                                        value={timestamp.time}
                                        onChange={(e) => updateTimestampField(index, "time", e.target.value)}
                                        className="flex-1 px-3 py-2 border rounded-md shadow-sm mr-2"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Title (e.g., Introduction)"
                                        value={timestamp.title}
                                        onChange={(e) => updateTimestampField(index, "title", e.target.value)}
                                        className="flex-1 px-3 py-2 border rounded-md shadow-sm"
                                    />
                                </div>
                            ))}
                            <button
                                onClick={addTimestampField}
                                className="mt-2 px-4 py-2 bg-gray-600 text-white rounded-md"
                            >
                                + Add Timestamp
                            </button>
                        </div>

                        {/* Submit Button */}
                        <button
                            // onClick={updateCourse002Timestamps}
                            onClick={updateLessonTimes}
                            className={`w-full py-2  btn btn-primary rounded-md text-white font-semibold transition ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}`}
                            disabled={loading}
                        >
                            {loading ? "Updating..." : "Update TimeStamp"}
                        </button>


                    </div>
                </div>
            </>
        </>
    );
};

export default CourseTimestampUpdate;
